import React from 'react';
import { Link } from 'react-router-dom';

// import { withRouter } from 'react-router-dom';

import './footer-link-block.styl';

class FooterLinkBlock extends React.Component {
  render() {
    return (
      <div className="footer-link-block">
        { (this.props.nameAddress &&
          <Link to={ this.props.nameAddress } className="footer-link-block__title">{ this.props.name }</Link>) ||
          <span className="footer-link-block__title">{ this.props.name }</span>
        }
        <ul className="footer-link-block__links">
          { this.props.links.map(link => {
            return (
              <li key={ link.text } >
                { link.isExternal &&
                  <a href={ link.address } target="_blank">{ link.text }</a>
                }
                { !link.isExternal &&
                  <Link to={ link.address }>{ link.text }</Link>
                }
              </li>
            );
          }) }
        </ul>
      </div>
    );
  }
}

export default FooterLinkBlock;



// WEBPACK FOOTER //
// ./src/containers/footer/footer-link-block/footer-link-block.js